import { IEnvironment } from './ienvironment'

export const environment: IEnvironment = {
  production: false,
  name: 'test',
  apiPath: 'http://52.142.127.186/',
  apiPath_https: 'http://52.142.127.186/',
  keyGate: 'Key/',
  keysGate: 'Keys/',
  heartbeatGate: 'Heartbeat/',
  hotelGate: 'Hotel/',
  securityGate: 'Security/',
  paymentGate: 'Payment/',
  bookingGate: 'Booking/',
  statisticsGate: 'Statistics/',
  supportGate: 'Support/',
  broadcastGate: 'Broadcast/',
  invoiceGate: 'Invoice/',
  AgInvoiceGate: 'AGInvoice/',
  flowGate: 'http://flow.test.aeroguest.io/',
  flowStagingGate: 'http://flow.test.aeroguest.io/',
  siteServiceGate: 'SftpClient/',
  userGate: 'User/',
  socialGate: 'Social/',
  loyaltyGate: 'Loyalty/',
  serviceGate: 'Service/',
  contentGate: 'Content/',
  PoSGate: 'Pos/',
  userGate2: 'User/',
  vaerifyHotelGate: 'VG/Hotel/',
  vaerifyUserGate: 'VG/User/',
  channelManagerGate: 'ChannelManager/',
  entryGate: 'Entry/',
  websocketGate: 'wss://api.aeroguest.io/UserWS',
  pmsGate: 'Pms/',
  utilityGate: 'Utility/',
  communicationGate: 'Communication/',
  authGate: 'Auth/',
  alarmGate: 'Alarm/'
}
